module.exports = __webpack_public_path__ + "static/axenture-logo-b77f725b20c5ff7da8bea64cecb7af13.png";